<template>
  <div>
    <div class="header_nav">
      <ul class="nav_list">
        <!-- nav最大值10 -->
        <router-link :class="{ side: typelist0 }" to="/" active-class="side" tag="li" exact>首页</router-link>
       
        <!-- <router-link :class="{ side: typelist3 }" :to="{ path: '/publicclass_list', query: { nav: 3 } }" active-class=""
          tag="li">公开课</router-link> -->
       
          <router-link :class="{ side: typelist11 }" :to="{ path: '/practice_system_list2', query: { nav: 11 } }"
          active-class="" tag="li">单项练习</router-link>
        <router-link :class="{ side: typelist10 }" :to="{ path: '/practice_system_list', query: { nav: 10 } }"
          active-class="" tag="li">套题模考</router-link>
          <router-link :class="{ side: typelist5 }" :to="{ path: '/languageTest', query: { nav: 5 } }" active-class=""
          tag="li">入学测试</router-link>
          <router-link :class="{ side: typelist8 }" :to="{ path: '/course', query: { nav: 8 } }" active-class=""
          tag="li">精品课程</router-link>
        <router-link :class="{ side: typelist7 }" :to="{ path: '/downloads', query: { nav: 7 } }" active-class=""
          tag="li">客户端</router-link>
      </ul>
    </div>

    <div class="Popup">
      <div class="Popup_Tan" v-for="(item,index) in tabPopupList" v-show="index == tanPage&&tanPageShow ==true">
        <div class="Popup_Tan_box">
          <span class="Popup_Tan_close el-icon-close" @click="tanClose(index)"></span>
          <a :href="item.C_Url" target="_blank"><img :src="item.C_Image" :alt="item.C_Title"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        ulList: "",
        navDover: false,
        wws: false,
        navside: "9",
        navItems: "",
        typelist0: "",
        typelist1: "",
        typelist2: "",
        typelist3: "",
        typelist4: "",
        typelist5: "",
        typelist6: "",
        typelist7: "",
        typelist8: "",
        typelist9: "",
        typelist10: "",
        typelist11: "",
        xun: 0,
        tanPage: 0,
        tanPageShow: false,
        tabPopupList: [],
      };
    },
    methods: {
      navS(index) {
        this.wws = true;
        this.navside = index;
        this.NavCourse(index);
      },
      navover(index) {
        this.navDover = true;
      },
      navout(index) {
        this.navDover = false;
        this.wws = false;
        this.navside = 9;
      },
      NavCourse(index) {
        let that = this;
        this.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/NavCourse?courserType=" +
            index
          )
          .then(function(result) {
            // // console.log(result);
            that.policyDtos = result.data.results;
            let dataArr = [];
            that.policyDtos.map(mapItem => {
              if (dataArr.length == 0) {
                dataArr.push({
                  date: mapItem.ScoreType,
                  CourseTypeName: mapItem.CourseTypeName,
                  ScoreTypeName: mapItem.ScoreTypeName,
                  List: [mapItem]
                });
              } else {
                let res = dataArr.some(item => {
                  //判断相同类型，有就添加到当前项
                  if (item.date == mapItem.ScoreType) {
                    item.List.push(mapItem);
                    return true;
                  }
                });
                if (!res) {
                  //如果没找相同类型添加一个新对象
                  dataArr.push({
                    date: mapItem.ScoreType,
                    CourseTypeName: mapItem.CourseTypeName,
                    ScoreTypeName: mapItem.ScoreTypeName,
                    List: [mapItem]
                  });
                }
              }
            });
            // // console.log(dataArr)
            that.navItems = dataArr.reverse();
          })
          .catch(function(error) {
            // console.log(error);
          });
      },

      getDialog(index) {
        let that = this;
        this.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/Dialog?platform=3&pageInfoTypeId=" + index
          )
          .then(function(result) {
            that.tabPopupList = result.data.results;
            let Seconds = that.tabPopupList[that.tanPage].C_Seconds * 50;
            let timer = setTimeout(() => {
              that.tanPageShow = true;
              clearTimeout(timer);
            }, Seconds)
          })
          .catch(function(error) {
            // console.log(error);
          });
      },
      tanClose(index) {
        let that = this;
        let idx = index;
        that.tanPageShow = false;
        that.tanPage++;
        if (that.xun == 1) {
          let newArrays = that.tabPopupList.filter(function(item) {
            return item.C_IsRepetition == true;
          });
          if (newArrays.length == 0) return; //判断是否存在循环弹窗
          if (that.tabPopupList[that.tanPage].C_IsRepetition == false) {
            that.tanClose(that.tanPage)
            return;
          }
        }
        console.log(that.tanPage)
        if (that.tanPage >= that.tabPopupList.length) {
          that.tanPage = 0
          that.xun = 1;
          return;
        }

        let Seconds = that.tabPopupList[that.tanPage].C_Seconds * 50;
        let timer = setTimeout(() => {
          that.tanPageShow = true;
          clearTimeout(timer);
        }, Seconds)

      },
    },
    created() {
      //自动触发写入的函数
      //    let a = sessionStorage.getItem('enum')
      // this.ulList = JSON.parse(a)[0].List
      var query = this.$route.query.nav;
      let index = 12; //板块id
      console.log("query", query)
      switch (query) {
        case undefined:
          this.typelist0 = true;
          index = 12;
          break;
        case "0":
          this.typelist0 = true;
          index = 12;
          break;
        case "1":
          this.typelist1 = true;
          index = 29;
          break;
        case "2":
          this.typelist2 = true;
          index = 32;
          break;
        case "3":
          this.typelist3 = true;
          index = 31;
          break;
        case "4":
          this.typelist4 = true;
          index = 12;
          break;
        case "5":
          this.typelist5 = true;
          index = 12;
          break;
        case "6":
          this.typelist6 = true;
          break;
        case "7":
          this.typelist7 = true;
          index = 12;
          break;
        case "8":
          this.typelist8 = true;
          index = 30;
          break;
        case "9":
          this.typelist9 = true;
          index = 12;
          break;
        case "10":
          this.typelist10 = true;
          index = 37;
          break;
        case "11":
          this.typelist11 = true;
          index = 38;
          break;
      }
      this.getDialog(index);
    },
  };
</script>

<style scoped>
  .header_nav {
    width: 100%;
    background: #ffffff;
    height: 80px;
  }

  .header_nav ul {
    float: left;
    width: 100%;
    display: flex;
  }

  .header_nav ul li {
    line-height: 80px;
    position: relative;
    font-size: 16px;
    color: #333333;
    cursor: pointer;
    padding: 0 20px;
  }

  .header_nav ul .side {
    background: #FF0659;
    color: #FFF;
  }

  .Popup_Tan {
    width: 500px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .Popup_Tan_box {
    width: 100%;
    position: relative;
  }

  .Popup_Tan_box img {
    display: block;
    width: 100%;
    height: auto;
  }

  .Popup_Tan_close {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 0;
    top: 0;
    font-size: 20px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/publicClass_header.vue